import React from 'react';
import Modal, { ModalFooter } from '@amzn/meridian/modal';
import Row from '@amzn/meridian/row';
import Button from '@amzn/meridian/button';
import Text from '@amzn/meridian/text';
import Link from '@amzn/meridian/link';

interface ConfirmModalProps {
  modalTitle?: string;
  modalDescription?: string;
  width?: string;
  open: boolean;
  includeLink?: boolean;
  linkText?: string;
  linkUrl?: string;
  showCancelButton?: boolean;
  setOpen: (newOpen: boolean) => void;
  onConfirm: () => void;
}

/**
 * Default Component
 */
const ConfirmModal = (props: ConfirmModalProps) => {
  const {
    open,
    setOpen,
    onConfirm,
    modalTitle,
    modalDescription,
    width = '350px',
    includeLink = false,
    linkText = '',
    linkUrl = '',
    showCancelButton = true,
  } = props;
  const onClose = () => setOpen(false);

  return (
    <Modal
      title={modalTitle}
      open={open}
      onClose={onClose}
      scrollContainer="viewport"
      closeLabel="Close"
      aria-describedby="modal-description"
      width={width}
    >
      {/* Modal Body */}
      <Text id="modal-description">
        {modalDescription}
        {includeLink && (
          <>
            <br />
            <Link target="_blank" rel="noopener noreferrer" href={linkUrl}>
              {linkText}
            </Link>
          </>
        )}
      </Text>

      {/* Modal Footer */}
      <ModalFooter>
        <Row alignmentHorizontal="end" widths="fit">
          {showCancelButton && (
            <Button data-cy="confirm-modal__cancel" type="secondary" size="small" onClick={onClose}>
              Cancel
            </Button>
          )}
          <Button
            type="primary"
            size="small"
            data-cy="confirm-modal__confirm"
            onClick={() => {
              setOpen(false);
              onConfirm();
            }}
          >
            Confirm
          </Button>
        </Row>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmModal;
